<template>
    <div style="padding: 0rem 2.5rem;">
      <div class="title">
        <h4>
          Lista de Spare Parts
        </h4>
      </div>

    <div v-if="configInputs != 1" class="">
      <div>
        <div class="">
          <div class="row-1">
            <div class="one">
              <label class="col-form-label font-weight-bold">80ju Descrição: </label>
              <input
                v-model="v$.desc.$model"
                type="text"
                :class="['form-control', { error: v$.desc.$error }]"
              />
              <div class="text-red" v-if="v$.desc.$error">
                O campo Descrição deve conter no mínimo 3 caracteres.
              </div>
            </div>
          </div>

          <div class="one">
            <label> Quantidade: </label>
            <input
              v-model="v$.quantidade.$model"
              type="text"
              :class="['field', { error: v$.quantidade.$error }]"
              placeholder=""
            />
            <div class="text-red" v-if="v$.quantidade.$error">
              O campo quantidade deve conter no mínimo 1 valor numerico.
            </div>
          </div>

          <div class="one">
            <label> Observação: </label>
            <input
              v-model="v$.observacao.$model"
              type="text"
              class="field"
              placeholder=""
              :class="['field', { error: v$.observacao.$error }]"
            />
            <div class="text-red" v-if="v$.observacao.$error">
              O campo Descrição deve conter no mínimo 3 caracteres.
            </div>
          </div>

          <div class="one">
            <label style="color: #cccccc00;">Imagem</label>
            <div style="display: flex; gap: 1rem;">
              <label :class="['buttonaddimage', { 'image-added': file !== '' }]" for="fotoSpareParts"></label>
              <input
                  type="file"
                  accept="image/*"
                  @change="addFiles"
                  id="fotoSpareParts"
                  name="fotoSpareParts"
                  hidden
              />
              <div class="btn-produto">
                <button
                  @click="addInList"
                  type="button"
                  class="btn-button-produto"
                >
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tableHistorico" v-if="list_lsp.length>0">
      <table class="table">
        <thead>
          <tr>
            <!-- <th>Id</th> -->
            <td colspan="col">Descrição</td>
            <td colspan="col">Quantidade</td>
            <td colspan="col">Observação</td>
            <td colspan="col">Preview</td>
            <td colspan="col" v-if="configInputs != 1">Opção</td>
          </tr>
        </thead>
        <tbody v-for="l in list_lsp" :key="l.idp">
          <tr>
            <!-- <td>{{ l.id }}</td> -->
            <td data-title="Descrição">{{ l.desc }}</td>
            <td data-title="Quantidade">{{ l.quantidade }}</td>
            <td data-title="Observação">{{ l.observacao }}</td>
            <td data-title="Preview">
              <div class="image-section">
                <button type="button" @click="clickPreview(l.preview)">
                  <img height="40" width="40" :src="l.preview" class="image-view"/>
                </button>
              </div>
            </td>
            <td v-if="configInputs != 1" class="btnDelete">
              <button type="button" @click="clickDeleteLSP(l.id)">
                Excluir
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <h3 class="warning-none">Nenhum Spare part adicionado</h3>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, minValue } from "@vuelidate/validators";
export default {
  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      list_lsp: [],
      count: 0,
      id: "",
      desc: "",
      quantidade: "",
      observacao: "",
      preview: "",
      file: "",

      ListLSP: "",
    };
  },

  watch: {
    list_lsp: {
      deep: true,
      immediate: true,
      handler(newValue, OldValue) {
        this.$store.commit("MutationImagesLSP", newValue);
      },
    },
  },

  validations() {
    return {
      desc: {
        minLength: minLength(3),
      },
      quantidade: {
        minValueValue: minValue(1),
      },
      observacao: {
        minLength: minLength(3),
      },
    };
  },

  methods: {
    addFiles(event) {
      var input = event.target;

      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        this.file = input.files[0];
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.preview = e.target.result;
        };
        // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
        reader.readAsDataURL(input.files[0]);

        //Acionar $Emit para enviar o objeto quando um File for adicionado
      }
    },

    addInList() {
      if (
        this.v$.desc.$invalid == true ||
        this.v$.quantidade.$invalid == true ||
        this.v$.observacao.$invalid == true ||
        this.v$.desc.$model == "" ||
        this.v$.quantidade.$model == "" ||
        this.file == ""
      ) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Verifique os dados inputados !",
        });
      } else {
        this.count += 1;
        this.id = this.count;
        const data = {
          id: this.id,
          desc: this.desc,
          quantidade: this.quantidade,
          observacao: this.observacao,
          preview: this.preview,
          file: this.file,
        };

        this.list_lsp.push(data);
        this.$store.commit("MutationImagesLSP", this.list_lsp);
      }
    },

    clickPreview(base64) {
      this.$swal.fire({
        imageUrl: base64,
        imageWidth: 700,
        imageHeight: 400,
        imageAlt: "Custom image",
      });
      //  this.$swal('Hello Vue world!!!');
    },

    clickDeleteLSP(id) {
      let index = this.list_lsp.findIndex((element) => element.id === id);

      this.list_lsp.splice(index, 1);

      this.$store.commit("MutationImagesLSP", this.list_lsp);
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      if (dataQuery.ListSpareParts) {
        dataQuery.ListSpareParts.map((element) => {
          this.list_lsp.push({
            id: element.ID,
            desc: element.DESCRIPTION,
            quantidade: element.QUANTIDADE,
            observacao: element.OBSERVACAO,
            preview: `${this.$store.state.ImgURL}` + `${element.PATH_IMG}`,
            file: "",
          });
        });
      }
    },
  },
};
</script>
s
<style scoped>
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.content {
  padding: 1rem 2rem!important;
  opacity: 0;
  animation: fadeIn 1s ease forwards!important;
}

.main-title {
  width: 100%!important;
  text-align: center;
  font-size: 1.4rem;
  padding: 0rem 0rem 1rem;
}

.tableHistorico {
  width: 68rem;
}

thead {
  border-radius: 1rem;
  margin-bottom: 1rem;
}

.table thead tr td:first-child {
  border-top-left-radius: 8px!important;
  border-bottom-left-radius: 8px!important;
}

.table thead tr td:last-child {
  border-top-right-radius: 8px!important;
  border-bottom-right-radius: 8px!important;
}

.tableHistorico tbody tr:first-child td:first-child {
  border-top-left-radius: 8px!important;
  border-bottom-left-radius: 8px;
}

.tableHistorico tbody tr:last-child td:last-child {
  border-top-right-radius: 8px!important;
  border-bottom-right-radius: 8px;
}

thead tr td{
  font-size: 0.9rem;
  background-color: var(--green);
  color: white;
  margin: 1rem!important;
  height: 1.5rem!important;
}

tbody tr td{
  padding: 0.5rem!important;
}


.image-view {
  border-radius: 0.5rem !important;
  width: 50px;
  height: 50px;
  object-fit: cover; 
}

.button-image {
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-section {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.warning-none {
  text-align: center;
  color: red;
}

@media screen and (max-width: 1200px) {
  .tableHistorico {
    width: 100%;
  }

  .tableHistorico table,
  .tableHistorico thead,
  .tableHistorico tbody,
  .tableHistorico th,
  .tableHistorico td,
  .tableHistorico tr {
    display: block;
    width: 100%;
  }

  .tableHistorico thead {
    display: none; 
  }

  .tableHistorico tr {
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 0.5rem;
    padding: 1rem;
    background: #f9f9f9;
  }

  .tableHistorico td {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    font-size: 0.9rem;
    border-bottom: 1px solid #eee;
    width: 100%;
  }

  .tableHistorico td::before {
    content: attr(data-title);
    font-weight: bold;
    flex: 1;
    padding-right: 1rem;
    text-align: left;
    color: #333;
  }

  .tableHistorico td:last-child {
    border-bottom: none;
  }

  .image-section {
    justify-content: flex-end;
  }

  .button-image img {
    margin-left: auto;
  }
}
</style>
